import {Observable} from "rxjs";
import {Request} from "../request.abstract";
import {Permission} from "./api.models";
import {Observer} from "rxjs/Observer";

export class PermissionsEndpoint extends Request {
    protected cache: Permission[];
    protected cacheToken: string;

    collection(): Observable<Permission[]> {
        return Observable.create((observer: Observer<any>) => {
            if (this.cache && this.cacheToken === this.settings.token) {
                observer.next(this.cache);
                observer.complete();

                return;
            }

            this.get('/v1/permissions').subscribe(
                (permissions: Permission[]) => {
                    this.cache      = [];
                    this.cacheToken = this.settings.token;
                    permissions.forEach((permission: Permission) => {
                        this.cache.push(Object.assign(permission));
                    });

                    observer.next(permissions);
                },
                (error: any) => {
                    observer.error(error);
                },
                () => {
                    observer.complete();
                }
            );
        });
    }

    add(permission: Permission): Observable<Permission> {
        this.cache = null;

        return this.post('/v1/permissions', permission);
    }
    remove(id: number): Observable<Boolean> {
        this.cache = null;

        return this.delete('/v1/permissions/' + id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/permissions/api.service.ts